import React from "react";
import {
  GreenEllipse,
  RedEllipse,
  // RightArrowIcon,
} from "../../../../../Icons";
import SelectedCheckIcon from "../../../../../Common/SelectedCheckIcon";
// import { GetCurrenySymbol } from "../../../../../../helper";

const CardItem = ({ card, activeCardId }) => {
  return (
    <div
      key={card.id}
      className={`flex relative justify-between cursor-pointer border-2 shadow-sm rounded-3xl p-6 ${
        card.id === activeCardId
          ? "bg-option-selected border-primary-300"
          : "bg-background-surface border-divider hover:bg-option-hover"
      }`}
    >
      {card?.id === activeCardId && (
        <SelectedCheckIcon />
      )}
      <div className="flex">
        {card.status === "Active" ? (
          <img
            src={
              card.card_brand === "Visa"
                ? "assets/logos/visa-othercard-bg.png"
                : "assets/logos/match-move-othercard-bg.png"
            }
            alt="Other Cards"
            className="rounded-md"
          />
        ) : (
          <img
            src={`${
              card.card_provider === "MM"
                ? "assets/logos/match-move-othercard-bg.png"
                : "assets/logos/visa-othercard-bg.png"
            }`}
            alt="Other Cards"
            className={`rounded-md ${
              card.status !== "Active" ? "bg-zinc-400 opacity-60" : ""
            }`}
          />
        )}
        <div className="ml-3">
          <p className="text-text-primary text-sm font-medium max-w-[220px] whitespace-nowrap overflow-hidden text-ellipsis">{card.name}</p>
          <span className="flex items-center space-x-2">
            {card.status === "Active" ? <GreenEllipse /> : <RedEllipse />}
            <p className="text-text-secondary text-sm ">
              {card.status} | · · {card.card_number.slice(-4)}
            </p>
          </span>
        </div>
      </div>

      {/* <div className="flex items-center justify-center space-x-0.5 text-text-primary text-sm font-medium leading-tight tracking-tight">
        <span>{GetCurrenySymbol("USD", "16", "16")}</span>
        <p className="text-text-primary font-normal">{card.balance}</p>
      </div> */}
    </div>
  );
};

export default CardItem;
